import CompanyOverview from './components/CompanyOverview';
import VisionMission from './components/VisionMission';
import CoreCapabilities from './components/CoreCapabilities';
import History from './components/History';

export default function AboutPage() {
  return (
    <div className="pt-20">
      <CompanyOverview />
      <VisionMission />
      <CoreCapabilities />
      <History />
    </div>
  );
}
